module.exports = __webpack_public_path__ + "static/media/BusseltonDunsborougTimes-socshare-min.7f39e99d.jpg";